import {DEFAULT_REDIRECT} from '../config/config.js'
import {PERMS} from '../config/permissions'
// use import for system components
// for prevent recursive async chunk loading error if user have wrong cached files
// шаблоны
import MainLayout from '../common/layout/main-layout.vue'
import AuthLayout from '../common/layout/auth-layout.vue'
import AccountUserProfileLayout from '../app/account/UserProfileLayout.vue'
// main
import MainError from '../app/main/Error.vue'
// авторизация/регистрация
import AuthLogin from '../app/auth/Login.vue'
import AuthRegisterSetPassword from '../app/auth/RegisterSetPassword.vue'
import AuthRequestResetPassword from '../app/auth/RequestResetPassword.vue'
import PublicFile from "../app/public-files/PublicFile";

// личный кабинет пользователя
const AccountUserProfile = () => import(/* webpackChunkName: "sverd.account" */ '../app/account/UserProfile.vue');

// карта
const GeoObjects = () => import(/* webpackChunkName: "buryatia.geo" */ '../app/geo/region.buryatia/Objects.vue');
const GeoTreads = () => import(/* webpackChunkName: "sverd.geo" */ '../app/geo/Threads.vue');
const GeoForecasts = () => import(/* webpackChunkName: "sverd.geo" */ '../app/geo/Forecasts.vue');
// АПО = зоны региональных операторов
const GeoApos = () => import(/* webpackChunkName: "sverd.geo" */ '../app/geo/Apos');
const GeoApoUpdate = () => import(/* webpackChunkName: "sverd.geo" */ '../app/geo/ApoUpdate');

// АТУ: административно терр устройств
const AtuObjects = () => import(/* webpackChunkName: "sverd.atu" */ '../app/atu/Objects.vue');
const AtuObjectUpdate = () => import(/* webpackChunkName: "sverd.atu" */ '../app/atu/ObjectUpdate.vue');

// целевые показатели
const TargetTargets = () => import(/* webpackChunkName: "sverd.target" */ '../app/target/Targets.vue');
const TargetTargetUpdate = () => import(/* webpackChunkName: "sverd.target" */ '../app/target/TargetUpdate.vue');

// отходообразователи
const GarbageDefenses = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/Defenses.vue');
const GarbageDefenseUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/DefenseUpdate.vue');
const GarbageOrganizations = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/Organizations.vue');
const GarbageOrganizationUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/OrganizationUpdate.vue');

const GarbageDeposits = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/Deposits.vue');
const GarbageDepositsUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/DepositsUpdate.vue');

const GarbageFactories = () => import(/* webpackChunkName: "default.garbage" */ '../app/garbage/Factories.vue');
const GarbageFactoriesUpdate = () => import(/* webpackChunkName: "default.garbage" */ '../app/garbage/FactoriesUpdate.vue');

const GarbageDormitories = () => import(/* webpackChunkName: "default.garbage" */ '../app/garbage/Dormitories.vue');
const GarbageDormitoriesUpdate = () => import(/* webpackChunkName: "default.garbage" */ '../app/garbage/DormitoriesUpdate.vue');

const GarbageCountryCommunities = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/CountryCommunities.vue');
const GarbageCountryCommunityUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/CountryCommunityUpdate.vue');
const GarbageGarages = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/Garages.vue');
const GarbageGarageUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/GarageUpdate.vue');
const GarbageIndividualAreas = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/IndividualAreas.vue');
const GarbageIndividualAreaUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/IndividualAreaUpdate.vue');
const GarbageManagers = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/Managers.vue');
const GarbageManagerUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/ManagerUpdate.vue');
const GarbageMedics = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/Medics.vue');
const GarbageMedicUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/MedicUpdate.vue');
const GarbageSettlements = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/Settlements.vue');
const GarbageSettlementUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/SettlementUpdate.vue');
const GarbageApartmentBuildings = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/ApartmentBuildings.vue');
const GarbageApartmentBuildingUpdate = () => import(/* webpackChunkName: "sverd.garbage" */ '../app/garbage/ApartmentBuildingUpdate.vue');

// мсн: места сбора и накопления
const MsnSeparateCollections = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/SeparateCollections.vue');
const MsnSeparateCollectionUpdate = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/SeparateCollectionUpdate.vue');
const MsnWithContainers = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/WithContainers.vue');
const MsnWithContainerUpdate = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/WithContainerUpdate.vue');
const MsnWithoutContainers = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/WithoutContainers.vue');
const MsnWithoutContainerUpdate = () => import(/* webpackChunkName: "sverd.msn" */ '../app/msn/WithoutContainerUpdate.vue');

// импорт файлов
const ImportImportExcel = () => import(/* webpackChunkName: "sverd.import" */ '../app/import/ImportExcel.vue');

// несанкцс свалки
const UnauthorizedHeaps = () => import(/* webpackChunkName: "sverd.unauthorized" */ '../app/unauthorized/Heaps.vue');
const UnauthorizedHeapUpdate = () => import(/* webpackChunkName: "sverd.unauthorized" */ '../app/unauthorized/HeapUpdate.vue');
const UnauthorizedWpf = () => import(/* webpackChunkName: "sverd.unauthorized" */ '../app/unauthorized/Wpf.vue');

// операторы
const RegistryOperators = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/Operators.vue');
const RegistryOperatorAllUpdate = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/OperatorAllUpdate.vue');
const RegistryRegionalOperators = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/RegionalOperators.vue');
const RegistryContracts = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/Contracts.vue');
const RegistryContractsUpdate = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/ContractsUpdate.vue');
const RegistryObjects = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/Objects.vue');
const RegistryObjectUpdate = () => import(/* webpackChunkName: "sverd.registry" */ '../app/registry/ObjectUpdate.vue');

// кадастры
const ClassifierFkko = () => import(/* webpackChunkName: "sverd.classifier" */ '../app/classifier/Fkko.vue');
const ClassifierFkkoUpdate = () => import(/* webpackChunkName: "sverd.classifier" */ '../app/classifier/FkkoUpdate.vue');
const ClassifierGarbage = () => import(/* webpackChunkName: "sverd.classifier" */ '../app/classifier/Garbage.vue');
const ClassifierGroro = () => import(/* webpackChunkName: "sverd.classifier" */ '../app/classifier/Groro.vue');
const ClassifierTechs = () => import(/* webpackChunkName: "sverd.classifier" */ '../app/classifier/Techs.vue');
const ClassifierTechUpdate = () => import(/* webpackChunkName: "sverd.classifier" */ '../app/classifier/TechUpdate.vue');

// администрирование
const AccessUsers = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/Users.vue');
const AccessUsersGroups = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/UsersGroups.vue');
const AccessUserUpdate = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/UserUpdate.vue');
const AccessUserGroupsUpdate = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/UserGroupsUpdate.vue');
const AccessJournals = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/Journals.vue');

// аналитика
const AnalyticCharts = () => import(/* webpackChunkName: "sverd.analytic" */ '../app/analytic/Charts.vue');
const AnalyticChart = () => import(/* webpackChunkName: "sverd.analytic" */ '../app/analytic/Chart.vue');
const AnalyticReports = () => import(/* webpackChunkName: "sverd.analytic" */ '../app/analytic/Reports.vue');
const AnalyticReportDownload = () => import(/* webpackChunkName: "sverd.analytic" */ '../app/analytic/ReportDownload.vue');

// разработка
const DevelopmentSettingUpdate = () => import(/* webpackChunkName: "sverd.development" */ '../app/development/SettingUpdate.vue');
const HeatMapSettings = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/HeatMapSettings.vue');
const HeatMapSettingsUpdate = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/HeatMapSettingsUpdate.vue');
const HeatMapTariffsSettings = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/HeatMapTariffsSettings.vue');
const HeatMapTariffsSettingsUpdate = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/HeatMapTariffsSettingsUpdate.vue');
const HeatMapPopulationSettings = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/HeatMapFormedSettings');
const HeatMapPopulationSettingsUpdate = () => import(/* webpackChunkName: "sverd.access" */ '../app/access/HeatMapFormedSettingsUpdate');

let routes = [
  { path: '/main', name: 'main', component: MainLayout, meta: {requiresAuth: false},
    children: [
      {path: 'error', name: 'main.error', component: MainError, meta: {requiresAuth: false, title: 'Ошибка', noRouteCheck: true}}
    ]
  },
  { path: '/auth', name: 'auth', component: AuthLayout, meta: {requiresAuth: false},
    children: [
      {path: 'login', name: 'auth.login', component: AuthLogin, alias: '/login', meta: {requiresAuth: false, title: 'Вход'}},
      {path: 'set-password', name: 'auth.registerSetPassword', component: AuthRegisterSetPassword, alias: '/set-password', meta: {requiresAuth: false, havePerms: [PERMS.CREATE, PERMS.EDIT], title: 'Установка пароля'}},
      {path: 'request-reset-password', name: 'auth.requestResetPassword', component: AuthRequestResetPassword, alias: '/request-reset-password', meta: {requiresAuth: false, havePerms: [PERMS.CREATE, PERMS.EDIT], title: 'Восстановление пароля'}}
    ]
  },
  { path: '/terShema', component: MainLayout, name: 'geo', meta: {title: 'Территориальная схема', number: '01', requiresAuth: false},
    redirect: { name: 'geo.objects' },
    children: [
      {
        path: '/', component: GeoObjects, name: 'geo.objects', meta: {title: 'Карта объектов', requiresAuth: false},
        children: [
          {path: 'defense-update/:id', name: 'geo.objects.defense.update', component: GarbageDefenseUpdate, meta: {requiresAuth: false}},
          {path: 'organization-update/:id', name: 'geo.objects.organization.update', component: GarbageOrganizationUpdate, meta: {requiresAuth: false}},
          {path: 'medic-update/:id', name: 'geo.objects.medic.update', component: GarbageMedicUpdate, meta: {requiresAuth: false}},
          {path: 'manager-update/:id', name: 'geo.objects.manager.update', component: GarbageManagerUpdate, meta: {requiresAuth: false}},
          {path: 'individual-area-update/:id', name: 'geo.objects.individualArea.update', component: GarbageIndividualAreaUpdate, meta: {requiresAuth: false}},
          {path: 'country-community-update/:id', name: 'geo.objects.countryCommunity.update', component: GarbageCountryCommunityUpdate, meta: {requiresAuth: false}},
          {path: 'garage-update/:id', name: 'geo.objects.garage.update', component: GarbageGarageUpdate, meta: {requiresAuth: false}},
          {path: 'with-container-update/:id', name: 'geo.objects.withContainer.update', component: MsnWithContainerUpdate, meta: {requiresAuth: false}},
          {path: 'without-container-update/:id', name: 'geo.objects.withoutContainer.update', component: MsnWithoutContainerUpdate, meta: {requiresAuth: false}},
          {path: 'separate-update/:id', name: 'geo.objects.separate.update', component: MsnSeparateCollectionUpdate, meta: {requiresAuth: false}},
          {path: 'heap-update/:id', name: 'geo.objects.heap.update', component: UnauthorizedHeapUpdate, meta: {requiresAuth: false}},
          {path: 'unauth-update/:id', name: 'geo.objects.unauth.update', component: RegistryObjectUpdate, meta: {requiresAuth: false}},
          {path: 'object-update/:id', name: 'geo.objects.object.update', component: RegistryObjectUpdate, meta: {requiresAuth: false}},
          {path: 'settlement-update/:id', name: 'geo.objects.settlement.update', component: GarbageSettlementUpdate, meta: {requiresAuth: false}},
          {path: 'operator-update/:id', name: 'geo.objects.operator.update', component: RegistryOperatorAllUpdate, meta: {requiresAuth: false}},
          {path: 'apartment-building-update/:id', name: 'geo.objects.apartmentBuildings.update', component: GarbageApartmentBuildingUpdate, meta: {requiresAuth: false}}
        ]
      },
      {
        path: 'potokShema', component: GeoTreads, name: 'geo.treads', meta: {title: 'Схема потоков', requiresAuth: false},
        children: [
          {path: 'defense-update/:id', name: 'geo.treads.defense', component: GarbageDefenseUpdate, meta: {requiresAuth: false}}
        ]
      },
      {
        path: 'forecasts', component: GeoForecasts, name: 'geo.forecasts', meta: {title: 'Моделирование', requiresAuth: false},
        children: [
          {path: 'create', name: 'geo.forecasts.object.create', component: RegistryObjectUpdate, meta: {requiresAuth: false}},
          {path: 'update/:id', name: 'geo.forecasts.object.update', component: RegistryObjectUpdate, meta: {requiresAuth: false}}
        ]
      },
      { path: 'apos', component: GeoApos, name: 'geo.apos', meta: {title: 'Зоны деятельности'},
        children: [
          {path: 'create', name: 'geo.apos.create', component: GeoApoUpdate},
          {path: 'update/:id', name: 'geo.apos.update', component: GeoApoUpdate}
        ]
      }
    ]
  },
  { path: '/admTerUstr', component: MainLayout, name: 'atu', meta: {title: 'Административно-территориальное устройство', number: '02'},
    redirect: { name: 'atu.objects' },
    children: [
      {
        path: '', name: 'atu.objects', component: AtuObjects, meta: {title: 'Административно-территориальное устройство', hideInMenu: true},
        children: [
          {path: 'create', name: 'atu.objects.create', component: AtuObjectUpdate},
          {path: 'update/:id', name: 'atu.objects.update', component: AtuObjectUpdate}
        ]
      }
    ]
  },
  { path: '/targets', component: MainLayout, name: 'target', meta: {title: 'Целевые показатели', number: '03'},
    redirect: { name: 'target.targets' },
    children: [
      {
        path: '', name: 'target.targets', component: TargetTargets, meta:  {title: 'Целевые показатели', hideInMenu: true },
        children: [
          {path: 'create', name: 'target.targets.create', component: TargetTargetUpdate, meta:  {title: 'Целевые показатели'} },
          {path: 'update/:id', name: 'target.targets.update', component: TargetTargetUpdate, meta:  {title: 'Целевые показатели'} }
        ]
      }
    ]
  },
  { path: '/othodoobrazovateli', component: MainLayout, name: 'garbage', meta: {title: 'Отходообразователи', number: '04'},
    redirect: { name: 'garbage.organizations' },
    children: [
      {
        path: 'ip', component: GarbageOrganizations, name: 'garbage.organizations', meta: {title: 'Организация/ИП'},
        children: [
          {path: 'create', name: 'garbage.organizations.create', component: GarbageOrganizationUpdate},
          {path: 'update/:id', name: 'garbage.organizations.update', component: GarbageOrganizationUpdate}
        ]
      },
      {
        path: 'minob', component: GarbageDefenses, name: 'garbage.defenses', meta: {title: 'Объекты министерства обороны'},
        children: [
          {path: 'create', name: 'garbage.defenses.create', component: GarbageDefenseUpdate},
          {path: 'update/:id', name: 'garbage.defenses.update', component: GarbageDefenseUpdate}
        ]
      },
      {
        path: 'med', component: GarbageMedics, name: 'garbage.medics', meta: {title: 'Медицинские учреждения'},
        children: [
          {path: 'create', name: 'garbage.medics.create', component: GarbageMedicUpdate},
          {path: 'update/:id', name: 'garbage.medics.update', component: GarbageMedicUpdate}
        ]
      },
      {
        path: 'uprav', component: GarbageManagers, name: 'garbage.managers', meta: {title: 'Управляющие организации'},
        children: [
          {path: 'create', name: 'garbage.managers.create', component: GarbageManagerUpdate},
          {path: 'update/:id', name: 'garbage.managers.update', component: GarbageManagerUpdate}
        ]
      },
      {
        path: 'individ', component: GarbageIndividualAreas, name: 'garbage.individualAreas', meta: {title: 'Индивидуальное домовладение'},
        children: [
          {path: 'create', name: 'garbage.individualAreas.create', component: GarbageIndividualAreaUpdate},
          {path: 'update/:id', name: 'garbage.individualAreas.update', component: GarbageIndividualAreaUpdate}
        ]
      },
      {
        path: 'garden', component: GarbageCountryCommunities, name: 'garbage.countryCommunitys', meta: {title: 'Садовые, дачные партнерства'},
        children: [
          {path: 'create', name: 'garbage.countryCommunitys.create', component: GarbageCountryCommunityUpdate},
          {path: 'update/:id', name: 'garbage.countryCommunitys.update', component: GarbageCountryCommunityUpdate}
        ]
      },
      {
        path: 'garage', component: GarbageGarages, name: 'garbage.garages', meta: {title: 'Гаражно-строительные кооперативы'},
        children: [
          {path: 'create', name: 'garbage.garages.create', component: GarbageGarageUpdate},
          {path: 'update/:id', name: 'garbage.garages.update', component: GarbageGarageUpdate}
        ]
      },
      {
        path: 'village', component: GarbageSettlements, name: 'garbage.settlements', meta: {title: 'Деревни, поселки, села'},
        children: [
          {path: 'create', name: 'garbage.settlements.create', component: GarbageSettlementUpdate},
          {path: 'update/:id', name: 'garbage.settlements.update', component: GarbageSettlementUpdate}
        ]
      },
      {
        path: 'apartment-buildings', component: GarbageApartmentBuildings, name: 'garbage.apartmentBuildings', meta: {title: 'Многоквартирные дома'},
        children: [
          {path: 'create', name: 'garbage.apartmentBuildings.create', component: GarbageApartmentBuildingUpdate},
          {path: 'update/:id', name: 'garbage.apartmentBuildings.update', component: GarbageApartmentBuildingUpdate}
        ]
      },
      {
        path: 'garbage-deposits', component: GarbageDeposits, name: 'garbage.deposits', meta: {title: 'Месторождения, лицензионные участки'},
        children: [
          {path: 'create', name: 'garbage.deposits.create', component: GarbageDepositsUpdate},
          {path: 'update/:id', name: 'garbage.deposits.update', component: GarbageDepositsUpdate}
        ]
      },
      {
        path: 'garbage-factories', component: GarbageFactories, name: 'garbage.factories', meta: {title: 'Фактории'},
        children: [
          {path: 'create', name: 'garbage.factories.create', component: GarbageFactoriesUpdate},
          {path: 'update/:id', name: 'garbage.factories.update', component: GarbageFactoriesUpdate}
        ]
      },
      {
        path: 'garbage-dormitories', component: GarbageDormitories, name: 'garbage.dormitories', meta: {title: 'Общежития'},
        children: [
          {path: 'create', name: 'garbage.dormitories.create', component: GarbageDormitoriesUpdate},
          {path: 'update/:id', name: 'garbage.dormitories.update', component: GarbageDormitoriesUpdate}
        ]
      },


    ]
  },
  { path: '/places/', component: MainLayout, name: 'msn', meta: {title: 'Места сбора и накопления', number: '05'},
    redirect: { name: 'msn.withContainers' },
    children: [
      {
        path: 'container', component: MsnWithContainers, name: 'msn.withContainers', meta: {title: 'Контейнерные площадки'},
        children: [
          {path: 'create', name: 'msn.withContainers.create', component: MsnWithContainerUpdate},
          {path: 'update/:id', name: 'msn.withContainers.update', component: MsnWithContainerUpdate}
        ]
      },
      {
        path: 'noContainer', component: MsnWithoutContainers, name: 'msn.withoutContainers', meta: {title: 'Бесконтейнерный сбор'},
        children: [
          {path: 'create', name: 'msn.withoutContainers.create', component: MsnWithoutContainerUpdate},
          {path: 'update/:id', name: 'msn.withoutContainers.update', component: MsnWithoutContainerUpdate}
        ]
      },
      {
        path: 'vtors', component: MsnSeparateCollections, name: 'msn.separateCollections', meta: {title: 'Пункты сбора вторсырья'},
        children: [
          {path: 'create', name: 'msn.separateCollections.create', component: MsnSeparateCollectionUpdate},
          {path: 'update/:id', name: 'msn.separateCollections.update', component: MsnSeparateCollectionUpdate}
        ]
      },
    ]
  },
  { path: '/svalki/', component: MainLayout, name: 'unauthorized', meta: {title: 'Несанкционированные свалки', number: '06'},
    redirect: { name: 'unauthorized.heaps' },
    children: [
      {
        path: '', component: UnauthorizedHeaps, name: 'unauthorized.heaps', meta: {title: 'Навалы мусора'},
        children: [
          {path: 'create', name: 'unauthorized.heaps.create', component: UnauthorizedHeapUpdate},
          {path: 'update/:id', name: 'unauthorized.heaps.update', component: UnauthorizedHeapUpdate}
        ]
      },
      {
        path: 'oro', component: UnauthorizedWpf, name: 'unauthorized.wpf', meta: {title: 'Несанкционированные ОРО'},
        children: [
          {path: 'create', name: 'unauthorized.wpf.create', component: RegistryObjectUpdate},
          {path: 'update/:id', name: 'unauthorized.wpf.update', component: RegistryObjectUpdate}
        ]
      }
    ]
  },
  { path: '/othObjects', component: MainLayout, name: 'garbageObjectRegistry', meta: {title: 'Реестр объектов по обращению с отходами', number: '07'},
    redirect: { name: 'registry.objects' },
    children: [
      { path: '', component: RegistryObjects, name: 'registry.objects', meta: {title: 'Реестр объектов по обращению с отходами', hideInMenu: true},
        children: [
          {path: 'create', name: 'registry.objects.create', component: RegistryObjectUpdate},
          {path: 'update/:id', name: 'registry.objects.update', component: RegistryObjectUpdate}
        ]
      }
    ]
  },
  { path: '/regisrty/', component: MainLayout, name: 'registry', meta: {title: 'Реестры', number: '08'},
    redirect: { name: 'registry.operators' },
    children: [
      {
        path: '', component: RegistryOperators, name: 'registry.operators', meta: {title: 'Операторы'},
        children: [
          {path: 'create', name: 'registry.operators.create', component: RegistryOperatorAllUpdate},
          {path: 'update/:id', name: 'registry.operators.update', component: RegistryOperatorAllUpdate}
        ],
      },
      {
        path: 'dogovors', component: RegistryContracts, name: 'registry.contracts', meta: {title: 'Договоры'},
        children: [
          {path: 'create', name: 'registry.contracts.create', component: RegistryContractsUpdate},
          {path: 'update/:id', name: 'registry.contracts.update', component: RegistryContractsUpdate}
        ]
      }
    ]
  },
  { path: '/analytics/', component: MainLayout, name: 'analytic', meta: {title: 'Аналитика', number: '09'},
    redirect: { name: 'analytic.charts' },
    children: [
      {path: 'chart/:chartId', component: AnalyticChart, name: 'analytic.chart', meta: {title: 'График', hideInMenu: true}},
      {path: 'charts', component: AnalyticCharts, name: 'analytic.charts', meta: {title: 'Аналитика', hideInMenu: true}},
      {
        path: 'reports', component: AnalyticReports, name: 'analytic.reports', meta: {title: 'Отчеты', hideInMenu: true},
        children: [
          {path: 'report/:reportId/:windowType', name: 'analytic.reports.report', component: AnalyticReportDownload, meta: {title: 'Отчеты'}}
        ]
      }
    ]
  },
  { path: '/cadastre/', component: MainLayout, name: 'classifier', meta: {title: 'Кадастр отходов', number: '10'},
    redirect: { name: 'classifier.fkko' },
    children: [
      {path: '', component: ClassifierFkko, name: 'classifier.fkko', meta: {title: 'Справочник отходов'},
        children: [
          {path: 'fkko-update/rootId-:rootId/pid-:pid/id-:id', name: 'classifier.fkko.update', component: ClassifierFkkoUpdate},
          {path: 'fkko-create/rootId-:rootId/pid-:pid', name: 'classifier.fkko.create', component: ClassifierFkkoUpdate}
        ]
      },
      {path: 'groro', component: ClassifierGroro, name: 'classifier.groro', meta: {title: 'ГРОРО'}},
      {path: 'utilization', component: ClassifierTechs, name: 'classifier.tech', meta: {title: 'Банк данных технологий'},
        children: [
          {path: 'create', name: 'classifier.tech.create', component: ClassifierTechUpdate},
          {path: 'update/:id', name: 'classifier.tech.update', component: ClassifierTechUpdate}
        ]
      },
      {path: 'othod', component: ClassifierGarbage, name: 'classifier.garbage', meta: {title: 'Банк данных об отходах'}}
    ]
  },
  { path: '/regoperators/', component: MainLayout, name: 'regionalOperators', meta: {title: 'Региональные операторы', number: '11'},
    redirect: { name: 'registry.regionalOperators' },
    children: [
      { path: '/regoperators/', component: RegistryRegionalOperators, name: 'registry.regionalOperators', meta: {title: 'Региональные операторы', hideInMenu: true},
        children: [
          {path: 'update/:id', name: 'registry.regionalOperators.update', component: RegistryOperatorAllUpdate}
        ]
      }
    ]
  },
  { path: '/admin/', component: MainLayout, name: 'access', meta: {title: 'Администрирование', number: '12'},
    redirect: { name: 'access.users' },
    children: [
      { path: '', component: AccessUsers, name: 'access.users', meta: {title: 'Пользователи'},
        children: [
          {path: 'create', name: 'access.users.create', component: AccessUserUpdate},
          {path: 'update/:id', name: 'access.users.update', component: AccessUserUpdate}
        ]
      },
      { path: 'users-groups', component: AccessUsersGroups, name: 'access.usersGroups', meta: {title: 'Группы пользователей'},
        children: [
          {path: 'create', name: 'access.usersGroups.create', component: AccessUserGroupsUpdate},
          {path: 'update/:id', name: 'access.usersGroups.update', component: AccessUserGroupsUpdate}
        ]
      },
      { path: 'journals', component: AccessJournals, name: 'access.journals', meta: {title: 'Журнал изменений'}},
      {
        path: 'tariffs',
        component: HeatMapTariffsSettings,
        name: 'access.tariffs',
        meta: {title: 'Настройки теплокарты тарифы'},
        children: [
          {path: 'create', name: 'access.tariffs.create', component: HeatMapTariffsSettingsUpdate},
          {path: 'update/:id', name: 'access.tariffs.update', component: HeatMapTariffsSettingsUpdate}
        ]
      },
      {
        path: 'population',
        component: HeatMapSettings,
        name: 'access.population',
        meta: {title: 'Настройки теплокарты население'},
        children: [
          {path: 'create', name: 'access.population.create', component: HeatMapSettingsUpdate},
          {path: 'update/:id', name: 'access.population.update', component: HeatMapSettingsUpdate}
        ]
      },
      {
        path: 'formed',
        component: HeatMapPopulationSettings,
        name: 'access.formed',
        meta: {title: 'Настройки теплокарты образование'},
        children: [
          {path: 'create', name: 'access.formed.create', component: HeatMapPopulationSettingsUpdate},
          {path: 'update/:id', name: 'access.formed.update', component: HeatMapPopulationSettingsUpdate}
        ]
      },
      {
        path: 'public-files',
        component: PublicFile,
        name: 'access.publicFile',
        meta: {title: 'Управление материалами ТС',showBreadcrumbs: true}
      }
    ]
  },
  {path: '/import', component: MainLayout, name: 'import', meta: {title: 'Импорт данных', number: ' ', hideInMenu: true},
    children: [
      { path: 'excel', component: ImportImportExcel, name: 'import.importExcel', meta: {title: 'Импорт даннных', hideInMenu: true}}
    ]
  },
  { path: '/profile', component: AccountUserProfileLayout, name: 'account', meta: {title: 'Личный кабинет', number: '13', hideInMenu: true},
    redirect: { name: 'account.userProfile' },
    children: [
      { path: '', component: AccountUserProfile, name: 'account.userProfile', meta: {title: 'Личный кабинет', hideInMenu: true}}
    ]
  },
  { path: '/development', component: MainLayout, name: 'development', meta: {title: 'Разработка', number: '0', hideInMenu: true},
    redirect: { name: 'development.settingUpdate' },
    children: [
      { path: 'setting-update', component: DevelopmentSettingUpdate, name: 'development.settingUpdate', meta: {title: 'Меню разработки', hideInMenu: true}}
    ]
  },
  {
    path: '/public-files',
    component: MainLayout,
    name: 'publicFiles',
    meta: {title: 'Материалы территориальной схемы', requiresAuth: false},
    redirect: {name: 'publicFiles.files'},
    children: [
      {
        path: '',
        component: PublicFile,
        name: 'publicFiles.files',
        meta: {requiresAuth: false, showBreadcrumbs: false}
      }
    ]
  },
  {path: '*', redirect: DEFAULT_REDIRECT.default}
];

export default {
  /* mode: 'history', */
  linkActiveClass: 'active',
  routes: routes
}
